import { createResponseSchema } from '@mint-sdk/api-core';
import z from 'zod';

export const workspacePlatformsInUseSchema = createResponseSchema(z.string());
